// Copyright (C) AirWorks Solutions, Inc - All Rights Reserved
// DO NOT REDISTRIBUTE
// UNAUTHORIZED COPYING OF THIS FILE, ANY PART OR WHOLE, VIA ANY MEDIUM IS STRICTLY PROHIBITED
// PROPRIETARY AND CONFIDENTIAL

// The kind-section header that hosts a BulkDownloadRow, shared by the customer
// Data Sets panel and the admin project details list so the two panes cannot
// drift apart (D75/D81).
export const sectionHeaderStyles = (theme: any) => ({
  sectionHeader: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'nowrap',
    minHeight: theme.spacing(5),
    columnGap: theme.spacing(1),
    borderTop: `1px solid ${theme.palette.divider}`,
    marginTop: theme.spacing(0.5),
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(0.5),
  },
  sectionTitle: {
    flexShrink: 0,
    fontSize: theme.typography.caption.fontSize,
    fontWeight: 600,
    letterSpacing: '0.08em',
    textTransform: 'uppercase',
    color: theme.palette.text.secondary,
  },
});

const styles = (theme: any) => ({
  // Caption and button travel as one centered cluster: space-between
  // either squished them together or left a canyon, depending on selection.
  row: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    columnGap: theme.spacing(1.5),
    width: '100%',
  },
  // Stacked section headers right-align so every section's pill shares one
  // vertical edge regardless of title and caption widths (D83).
  rowEnd: {
    justifyContent: 'flex-end',
  },
  // The count carries the numbers so the button label can stay short. Never
  // wraps: a two-line caption would grow the row when a selection starts.
  count: {
    color: theme.palette.text.secondary,
    whiteSpace: 'nowrap',
  },
  // A labelled pill so the group action never reads as another per-row
  // download icon; contained variant signals an active selection.
  downloadButton: {
    textTransform: 'none',
    whiteSpace: 'nowrap',
    fontSize: theme.typography.caption.fontSize,
    lineHeight: 1.5,
    padding: theme.spacing(0.25, 1.25),
    // The contained variant carries an invisible border so both states box
    // out to the same height - no vertical shift when a selection starts.
    '&.MuiButton-contained': {
      border: '1px solid transparent',
    },
  },
});

export default styles;
